export interface TomatoProps {
  position: number;
  death: boolean;
  current: number;
  isLoading: boolean;
}

export enum TomatoState {
  Iddle,
  Walk1,
  Walk2,
  Win,
  Death,
}
